// app/frontend/pages/Onboarding/steps/StepLocation.tsx
import { Stack } from "@mantine/core";
import { StepShell } from "../../../components/ui/Stepper";
import { L2KInput, L2KSelect } from "../../../components/ui/Forms";
import type { StepComponentProps } from "../../../components/ui/Stepper";
import type { OnboardingFormValues } from "../types";

// Common countries for dance communities
const countries = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "UK", label: "United Kingdom" },
  { value: "AU", label: "Australia" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "ES", label: "Spain" },
  { value: "IT", label: "Italy" },
  { value: "NL", label: "Netherlands" },
  { value: "SE", label: "Sweden" },
  { value: "NO", label: "Norway" },
  { value: "DK", label: "Denmark" },
  { value: "BR", label: "Brazil" },
  { value: "MX", label: "Mexico" },
  { value: "JP", label: "Japan" },
  { value: "KR", label: "South Korea" },
  { value: "SG", label: "Singapore" },
  { value: "NZ", label: "New Zealand" },
  { value: "IE", label: "Ireland" },
  { value: "PT", label: "Portugal" },
  { value: "OTHER", label: "Other" },
];

export function StepLocation({ form }: StepComponentProps<OnboardingFormValues>) {
  return (
    <StepShell
      title="Where are you located?"
      subtitle="This helps us connect you with local dance events"
    >
      <Stack gap="md">
        <L2KSelect
          label="Country"
          placeholder="Select your country"
          data={countries}
          searchable
          {...form.getInputProps("country")}
        />

        <L2KInput
          label="City"
          placeholder="Enter your city"
          {...form.getInputProps("city")}
        />
      </Stack>
    </StepShell>
  );
}

export default StepLocation;
